import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import { store } from './app/store';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


const container = document.getElementById('root');
const root = createRoot(container);

root.render(<Provider store={store}> <App /></Provider>)
